import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import InfoIcon from '@ancon/wildcat-ui/shared/icons/info.svg'

import Button from '../../app/components/Button'
import BodyText from '../../app/components/BodyText'
import useAppDispatch from '../../../store/hooks/useAppDispatch'
import { outletSetIsVisibleOutletDetailsModal } from '../store/outletSlice'

import styles from './OutletMoreInfoButton.module.scss'

export default function OutletMoreInfoButton() {
  const dispatch = useAppDispatch()

  const { t } = useTranslation('outlet')

  function handleClick() {
    dispatch(outletSetIsVisibleOutletDetailsModal(true))
  }

  return (
    <Button
      variant="secondary"
      onClick={handleClick}
      className={styles.outletMoreInfoButton}
      outlined
    >
      <InfoIcon />
      <BodyText as="span">{t('moreInfo')}</BodyText>
    </Button>
  )
}
